export default __webpack_public_path__ + "images/0x88b3133333697fa94ddf129ec3de7defad501a98.png";